import styled, { css } from "styled-components";

export const StyledUnibox = styled.div`
  min-height: 100vh;
  flex-grow: 1;
  display: flex;
  overflow: hidden;
  transition: all 0.350s ease-in-out;
.trial-banner-visible & {
padding: 42px 0 0;
}


  .emals-section {
    display: flex;
    width: 100%;
    min-height: 100%;
    position: relative;

    .emptysecrren-holder{
      height:100vh;
      >div{
        height: 100%;
      }
    }
  }
`;

export const StyledDotsLoader = styled.div`
  padding: 20px 0 20px;
  display: flex;
  justify-content: center;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.99),
    transparent
  );
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 500px;

  ${({ $loaderBottom }) =>
    $loaderBottom &&
    css`
      align-items: flex-end;
      top: auto;
      bottom: 0;
      background: linear-gradient(
        to top,
        rgba(255, 255, 255, 0.99),
        transparent
      );
      height: 300px;
    `}

  .dots-loader {
    width: 50px;
    aspect-ratio: 2;
    --_g: no-repeat
      radial-gradient(circle closest-side, var(--primary-50) 90%, #0000);
    background:
      var(--_g) 0% 50%,
      var(--_g) 50% 50%,
      var(--_g) 100% 50%;
    background-size: calc(100% / 3) 50%;
    animation: l3 1s infinite linear;
  }

  @keyframes l3 {
    20% {
      background-position:
        0% 0%,
        50% 50%,
        100% 50%;
    }
    40% {
      background-position:
        0% 100%,
        50% 0%,
        100% 50%;
    }
    60% {
      background-position:
        0% 50%,
        50% 100%,
        100% 0%;
    }
    80% {
      background-position:
        0% 50%,
        50% 50%,
        100% 100%;
    }
  }
`;

export const StyledContentHolder = styled.div`
  width: 100%;
  max-width: 315px;
  background: var(--white);
  border-right: 1px solid #ddd;
  position: relative;
  @media (min-width: 1450px) {
    max-width: 350px;
  }

  .search-area,
  .sidebar-head,
  .filters-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 10px;
    border-bottom: 1px solid #ddd;

    @media (min-width: 1450px) {
      padding: 10px 12px;
    }

    .filter-box {
      position: relative;
    }

    h3 {
      margin: 0;
    }

    form {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-grow: 1;

      input {
        height: 44px;
        font-size: 14px;
        line-height: 18px;
        padding: 10px 15px;
        border-radius: 10px;
        border-color: rgba(28, 28, 28, 0.1);
      }
    }

    .btn-filter {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      border-radius: 10px;
      background: #fafafa;
      
      @media (min-width: 1450px) {
        width: 40px;
        height: 40px;
      }
    }

    .icon {
      cursor: pointer;
      color: var(--blue);
    }
    .unread-text {
      flex-shrink: 0;
      display: block;
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      color: #7f8594;
    }
  }

  .sidebar-head {
    padding: 20px 12px;
  }

  .filters-holder {
    position: relative;
    align-items: center;
    border-bottom: 1px solid #ddd;

    .filter-box {
      position: relative;
    }

    .btn-filter.active {
      background: #edf3ff;
      border-color: #c8dafb;
    }

    .filter-dropdown {
      position: absolute;
      top: calc(100% + 12px);
      left: 0;
      width: 610px;
      max-width: calc(100vw - 40px);
      padding: 20px;
      border-radius: 20px;
      border: 1px solid #e6e6e6;
      background: var(--white);
      box-shadow: 0 12px 30px rgba(35, 36, 42, 0.12);
      z-index: 30;
    }

    .filter-popover-head {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 0 0 16px;

      .clear-btn,
      .close-btn {
        background: transparent;
        border: none;
        color: #f04b3a;
        font-size: 16px;
        line-height: 1;
        margin-left: auto;
        cursor: pointer;
        padding: 0;
      }

      .close-btn {
        color: #5f5e85;
        margin-left: 10px;
      }
    }

    .selected-filters {
      min-height: 40px;
      max-height:120px;
      border: 1px solid #dbdce3;
      border-radius: 12px;
      background: #fff;
      padding: 8px 10px;
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      margin: 0 0 18px;
      overflow: auto;

      .chip-placeholder {
        font-size: 14px;
        line-height: 18px;
        color: #8d93a1;
      }

      .chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 10px;
        border-radius: 8px;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        background: #3f7df0;

        button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 16px;
          height: 16px;
          border: none;
          border-radius: 50%;
          padding: 0;
          color: #3f7df0;
          background: #fff;
          cursor: pointer;
        }
      }
    }

    .filter-section {
      display: flex;
      align-items: flex-start;
      gap: 50px;
      margin: 0 0 30px;

.dropdown-holder{
  max-width: 300px;
}

          label{
        margin: 0;
      }

      &.align-center{
        align-items: center;
      }

      svg{
        color: var(--text-color-50);
      }
    }



    .section-title {
      width: 100%;
      max-width: 150px;
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      color: #8e8d96;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex-shrink: 0;
    }

    .dropdown-holder{
      width: 100%;
      border-radius: 5px;
      background: var(--white);

      button{
        font-size: 14px;
        line-height: 18px;
        padding: 8px 14px;
      }

    }

    .option-group,
    .option-grid {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }
    
    .radio-option{
      padding: 5px 10px;
      border: 1px solid var(--gray-450);
      border-radius: 5px;
    }

    .option-pill {
      min-width: 126px;
      height: 44px;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding: 10px 14px;
      border-radius: 9px;
      border: 1px solid #d6d8df;
      background: #fff;
      color: #2f2f32;
      font-size: 15px;
      line-height: 19px;
      cursor: pointer;

      .dot {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid #c4c8d0;
        background: #fff;
      }

      &.active .dot {
        border-color: #3f7df0;
        box-shadow: inset 0 0 0 4px #fff;
        background: #3f7df0;
      }
    }

    .campaign-select-wrap {
      position: relative;

      select {
        width: 100%;
        height: 48px;
        border: 1px solid #d6d8df;
        border-radius: 9px;
        font-size: 15px;
        line-height: 19px;
        padding: 0 46px 0 14px;
        color: #2f2f32;
        background: #fff;
        appearance: none;
      }

      .select-icon {
        position: absolute;
        top: 50%;
        right: 14px;
        transform: translateY(-50%);
        color: #141414;
        pointer-events: none;
      }
    }


    .checkbox-option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      line-height: 19px;
      color: #2f2f32;

      input {
        width: 18px;
        height: 18px;
        margin: 0;
      }
    }

    .apply-filters-btn {
      width: 100%;
      height: 40px;
      border: none;
      border-radius: 12px;
      font-size: 16px;
      line-height: 20px;
      color: #fff;
      background: #3f7df0;
      cursor: pointer;
      margin: 12px 0 0;
    }
  }

  .no-found {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .infinite-scroll-component {
    overflow: hidden;
  }

  .col-holder {
    height: calc(100vh - 175px);
    overflow: auto;

    @media (min-width: 1450px) {
      height: calc(100vh - 187px);
    }
    transition: all 0.350s ease-in-out;
    .trial-banner-visible & {
  height: calc(100vh - 217px);
  @media (min-width: 1450px) {
      height: calc(100vh - 230px);

    }
}

    &::-webkit-scrollbar {
      width: 2px;
    }
  }
`;

export const StyledThreadListItem = styled.div`
  padding: 12px ;
  position: relative;
  cursor: pointer;
  @media (min-width: 1450px) {
    padding: 20px 25px;
  }

  ${({ $active }) =>
    $active &&
    css`
      background: #f9fbff;

      &::before {
        visibility: visible;
        opacity: 1;
      }
    `}

  .col-head,.info-box {
    display: flex;
    gap: 10px;

    .icon-box {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex-shrink: 0;
      width: 22px;

      .icon {
        display: block;
        font-size: 16px;
        color: #ccc;

        &.pin {
          margin: 0 0 0 -2px;
        }
      }
      .active-pin {
        color: #7f8996;
      }
      .active-star {
        color: #f3e400;
      }
    }


    .info-holder{
flex-grow: 1;
    }

    .info-box {
      margin: 0 0 10px;
    }

    .img-box {
      flex-shrink: 0;
      width: 35px;
      height: 35px;
      border-radius: 50px;
      overflow: hidden;

      @media (min-width: 1450px) {
        width: 40px;
        height: 40px;

      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .text-box {
      flex-grow: 1;
      font-size: 11px;
      line-height: 14px;
      color: #313131;

      @media (min-width: 1450px) {
        font-size: 13px;
        line-height: 16px;
      }

      p {
        color: #313131;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 2.4em;
        word-break: break-word;
      }

      .name {
        color: var(--black);
      }
    }
    .date-box {
      flex-shrink: 0;
      font-size: 12px;
      line-height: 15px;

      .date {
        display: block;
        text-align: right;
        color: #7f7f7f;
        text-transform: uppercase;
        margin: 0 0 5px;
      }

      .count {
        display: block;
        width: max-content;
        font-size: 12px;
        line-height: 14px;
        font-weight: 700;
        border-radius: 5px;
        padding: 3px 6px;
        color: var(--white);
        background: var(--blue);
        margin: 0 0 0 auto;
      }
    }

    .name-holder,
    .campaign-name-holder {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .name-icon {
      color: var(--blue);
      ${({ $threadType }) =>
    $threadType === "linkedin" &&
    css`
          color: var(--blue);
        `}
      ${({ $threadType }) =>
    $threadType === "email" &&
    css`
          color: #3f3f3f;
        `}
      ${({ $threadType }) =>
    $threadType === "ai" &&
    css`
          background: linear-gradient(270deg, #fa16f3 3.85%, #3a7def 96.15%);
          color: var(--white);
          padding: 2px 5px;
          border-radius: 5px;
        `}
    }
    .campaign-name-holder {
      width: max-content;
      background: #e5eeff;
      color: var(--blue);
      padding: 4px 7px;
      border-radius: 5px;

      ${({ $threadType }) =>
    $threadType === "linkedin" &&
    css`
          background: #e5eeff;
          color: var(--blue);
        `}
      ${({ $threadType }) =>
    $threadType === "email" &&
    css`
          background: #ececec;
          color: #3f3f3f;
        `}
      ${({ $threadType }) =>
    $threadType === "ai" &&
    css`
          background: #ececec;
          color: var(--white);
        `}
      .campaign-name {
        font-size: 11px;
        line-height: 15px;
        display: inline-block;
        max-width: 141px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: bottom;
        @media (min-width: 1450px) {
          font-size: 12px;
          line-height: 15px;
        max-width: 166px;
        }
      }
    }
  }

  .description {
    display: block;
    font-size: 15px;
    line-height: 19px;
    color: var(--text-color-50);
  }

  .name {
    display: block;
    width: max-content;
    max-width: 134px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: var(--text-color-50);
    text-transform: capitalize;
    @media (min-width: 1450px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  .text {
    p {
      display: none;
      &:first-child {
        display: block;
        width: 260px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0;
      }
    }
    br {
      display: none;
    }
    hr {
      display: none;
    }
  }
`;

export const StyledEmailMessages = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: var(--white);

  .no-messages-found {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .emails-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 65px;
    padding: 12px 15px;
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: #ddd;
    background: #f9fbff;
    @media (min-width: 1450px) {
      padding: 15px 25px;

    }

    .action-btn {
      display: flex;
      align-items: center;
      gap: 8px;

      .btn {
        display: block;
        font-size: 20px;
        color: #b2b2b2;
        &.pin {
          margin: 3px 0 0;
        }
      }
      .active-pin {
        color: #7f8996;
      }
      .active-star {
        color: #f3e400;
      }
    }

    .message-drop {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 14px;
      line-height: 18px;
      color: #7f8594;
    }

    .undo-redo {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 1px;
        height: 22px;
        background: #ddd;
      }

      .btn {
        display: block;
        font-size: 20px;
        color: #b2b2b2;
      }
    }

    .lead-info {
      display: flex;
      align-items: center;
      gap: 10px;

      .img-box {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        overflow: hidden;
        
        @media (min-width: 1450px) {
          width: 49px;
          height: 49px;
        }

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .name {
        display: block;
        font-size: 14px;
        line-height: 17px;
        font-weight: 500;
        color: var(--black);
        margin: 0 0 5px;
        
        @media (min-width: 1450px) {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }

    .campaign-name-holder {
      width: max-content;
      font-size: 11px;
      line-height: 13px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 5px;
      background: #e5eeff;
      color: var(--blue);
      padding: 4px 7px;
      border-radius: 5px;

      @media (min-width: 1450px) {
        font-size: 12px;
        line-height: 15px;

      }

      .campaign-text {
        padding: 0 5px 0 0;
        position: relative;
        flex-shrink: 0;
        &::before {
          content: "";
          position: absolute;
          top: -4px;
          right: 0;
          bottom: -4px;
          width: 1px;
          background: #b5d2f3;
        }
      }

      .campaign-name {
        display: inline-block;
        max-width: 220px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: bottom;
      }

      ${({ $threadType }) =>
    $threadType === "linkedin" &&
    css`
          background: #e5eeff;
          color: var(--blue);
        `}
      ${({ $threadType }) =>
    $threadType === "email" &&
    css`
          background: #ececec;
          color: #3f3f3f;
        `}
      ${({ $threadType }) =>
    $threadType === "ai" &&
    css`
          background: #ececec;
          color: var(--white);
        `}
    }
.more-details-btn{
  padding: 7px 10px;
  @media (max-width: 1449px) {
    padding: 5px 8px;
    font-size: 14px;
    line-height: 18px;
  }
}
  }



  .messages-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding:  0 16px 16px;
    position: relative;



    .messages-holder {
      flex-grow: 1;
      display: flex !important;
      flex-direction: column-reverse;
      height: calc(100vh - 410px);
      overflow: auto;
      padding: 0 5px 0 0;

&::-webkit-scrollbar {
  width: 2px;
}
      ${({ $send }) =>
    $send &&
    css`
        .email-heading,
        .email-subheading { {
          color: #2c2c2c;
        }
      `}

      display: block;
      font-size: 14px;
      line-height: 18px;
    }

    .email-opened {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 0 0 12px;

      .icon-holder {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #e8e9f1;
        border-radius: 50%;
      }

      .text-holder {
        flex-grow: 1;

        .email-heading {
          font-weight: 400;
        }
      }
    }
  }
  

  .input-holder {
    .header {
      width: 100%;

      .subtitle {
        display: block;
        font-size: 12px;
        line-height: 15px;
        color: #c5c5c5;
        margin: 0 0 6px;
      }
    }

    .hint-list {
      list-style: none;
      padding: 5px 10px;
      margin: 0 0 10px;
      border-radius: 50px;
      cursor: pointer;
      background: #f0f0f0;
    }

    .wrap {
      padding:13px 0 0;
      border-top: 1px solid #E5E5E5;
    }

    .response-head,.reply-type-holder,.btn-submit-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 12px;
      line-height: 15px;
      font-weight: 500;
      padding: 5px;

      .separator{
        display: flex;
        align-items: center;
        color: #7f8594;
        position: relative;
        margin-right: 5px;

        &::before {
          content: '';
          position: absolute;
          width: 6px;
          height: 6px;
          top: 5px;
          right: -3px;
          border-top: 1.5px solid #7f8594;
          border-right: 1.5px solid #7f8594;
          transform: rotate(45deg) ;
        }
      }


  .reply-type-holder{
gap: 5px;
background: #F3F3F3;
color: #3F3F3F;
border-radius: 5px;
padding: 5px 10px;

&.active{
  background: var(--blue);
  color: var(--white);
}
  }

      .user-email-select {
        .react-select__control {
          height: 35px;
          font-size: 12px;
          line-height: 16px;
          padding-right: 0;
          padding-left: 8px;
          border-color: var(--blue);
        }
      }


    }

    .textarea {
      padding: 10px;
      width: 100%;
      height: 90px;
      border: none;
      outline: none;
      border: 1px solid #E5E5E5;
      border-radius: 10px 10px 0 0;
      background: var(--white);
      resize: none;
    }

    .toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 5px ;
      border: 1px solid #E5E5E5;
      border-top: none;
      border-radius: 0 0 10px 10px;
      background: var(--white);

      .btn-wrap {
        display: flex;
        align-items: center;
        gap: 13px;

        .btn {
          font-size: 16px;
          color: #7f8594;
        }
      }
      .btn-submit-wrapper{
        justify-content: flex-end;
        flex-grow: 1;
        gap: 20px;
        padding: 0 ;

        .grd-color{
          display: block;
        }

        .btn-submit {
          padding: 7px 5px;
        }
      }
      }
  }
`;

export const StyledMessage = styled.div`
  position: relative;
  padding: 30px 10px 10px 55px;
  color: #2c2c2e;
  border-bottom: 1px solid #ddd;

  ${({ $isLast }) =>
    $isLast &&
    css`
      border-bottom: none;
    `}

  p {
    /* margin: 0 0 10px; */

    margin: 0;

    
    &:last-child {
      margin: 0;
    }
  }

  .message-head {
    display: flex;
    align-items: start;
    justify-content: space-between;
    gap: 10px;
    padding: 0;
    margin: 0 0 12px;
    border-radius: 10px;

    .img-box {
      position: absolute;
      top: 28px;
      left: 0;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50px;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .user-name-holder{
      margin: 0 0 5px;
    }

    .user-name-holder,.linkedin-icon-holder {
      display: flex;
      align-items: center;
      gap: 10px;
      
      .linkedin-icon-holder{
        font-size: 12px;
        line-height: 15px;
        gap: 5px;
        background: var(--blue);
        color: var(--white);
        padding: 4px 5px;
        border-radius: 5px;

        ${({ $threadType }) =>
    $threadType === "linkedin" &&
    css`
          background: var(--blue);
          color: var(--white);
        `}
      ${({ $threadType }) =>
    $threadType === "email" &&
    css`
          background: #ececec;
          color: #3f3f3f;
        `}
      ${({ $threadType }) =>
    $threadType === "ai" &&
    css`
          background: #ececec;
          color: var(--white);
        `}
      }
    }

    .email-heading{
      display: block;
      font-weight: 500;
      color: var(--black);
    }

    .email-subheading{
      display: block;
      color: var(--blue);
      margin: 0 0 8px;
    }

    .email-subject{
      display: block;
      font-size: 14px;
      line-height: 18px;
      color: var(--black);  
    }

    .date-and-time{
      display: flex;
      gap: 10px;
    }
  }



  ${({ $send }) =>
    $send &&
    css`
      position: relative;
      margin: 0 15px 32px 0;
      align-self: flex-end;
      color: var(--white);
      background: var(--blue);

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: auto;
        right: -15px;
        border-top: 17px solid var(--blue);
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
      }

      .message-head {
        display: none;
      }

      .email-message {
        p {
          color: var(--white) !important;
          a {
            color: var(--white) !important;
          }
        }
      }
    `}

  .email-greeting,
  .email-message {
    display: block;
    font-size: 14px;
    line-height: 20px;
    font-weight: 300;

    span {
      font-family: var(--base-font-sans-serif) !important;
    }
  }

  .email-message {
    color:#000;
    p{
      /* color:#656565; */
      color:#000;

    }
    a {
      word-break: break-all;
      text-decoration: underline;
      color: var(--blue);
    }
    ol {
      padding-left: 20px;
      list-style: decimal;
    }
    ul {
      padding-left: 20px;
      list-style: disc;
    }
    li {
      margin-bottom: 6px;
    }
    strong,
    b {
      font-weight: 600;
    }
  }

  .email-greeting {
    margin: 0 0 20px;
  }

  .message-time {
    display: block;
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    color: #7f8594;
    margin-top: 8px;
    opacity: 0.8;
  }

  ${({ $send }) =>
    $send &&
    css`
      .message-time {
        color: rgba(255, 255, 255, 0.8);
      }
    `}
`;

export const StyledMediaSidebar = styled.div`
  position: absolute;
  max-height: 500px;
  right: -100%;
  top: 90px;
  bottom: 20px;
  flex-shrink: 0;
  width: 100%;
  max-width: 280px;
  padding:  10px;
  background: var(--white);
  transition: 0.3s all ease-in-out;
  box-shadow: 0px 4px 20px 0px #0000001A;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;


  @media (min-width: 1450px) {
    max-width: 350px;
  }

  ${({ $active }) =>
    $active &&
    css`
      right: 15px;
      z-index: 110;
    `}
    
    .user-details-bg{
      width: 100%;
      height: 110px;
      flex-shrink: 0;
      background: linear-gradient(90deg, rgba(49, 123, 255, 0.25) 0%, rgba(183, 75, 255, 0.25) 50%, rgba(253, 180, 9, 0.25) 100%);
      border-radius: 10px 10px 30px 30px;

}

  .content-wrap {
    width: 100%;
    padding: 0 15px;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .info-holder {
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    .info-head {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 auto 35px;
      cursor: pointer;
      flex-shrink: 0;

      .img-box {
        width: 120px;
        height: 120px;
        border: 4px solid var(--white);
        border-radius: 50%;
        margin: -60px 0 20px; 
        overflow: hidden;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }


      .title {
        display: block;
        font-size: 22px;
        line-height: 26px;
        font-weight: 500;
        color: var(--black);
        margin: 0 0 5px;
      }

      .designation {
        display: block;
        font-size: 12px;
        line-height: 15px;
        color: #7f8594;
        margin: 0 0 5px;
        text-align: center;
      }

      .email{
        display: block;
        font-size: 12px;
        line-height: 15px;
        color: var(--blue);
      }
    }

.detail-holder{
padding-right: 3px;
flex: 1;
min-height: 0;
display: flex;
flex-direction: column;

.detail {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }


      .info-list {
        list-style: none;
        font-size: 14px;
        line-height: 18px;

        li {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 10px;
          font-size: 13px;
          line-height: 17px;
          margin: 0 0 13px;

          &:last-child {
            margin: 0;
          }
          .react-select__control {
            height: 30px;
            border-radius: 5px;
            padding-right: 10px;
            padding-left: 10px;

            .react-select__indicator {
              padding: 0;
            }
          }
        }

        .subtitle {
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 75px;
          color: #596064;
        }
        .text {
          display: block;
          text-align: right;
          color: #2C3437;
          word-break: break-word;
          overflow-wrap: break-word;

          &.email {
            color: var(--blue);
          }
        }

        .icon{
          flex-shrink: 0;
        }
      }

      &.last-activities{
        margin: 0;
        .subtitle{
           font-weight: 600;
        }

        .icon{
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: #e5eeff;
          color: var(--blue);
          border-radius: 50%;
          padding: 2px;
        }
      }
    }
  }

  .heading {
    display: block;
    color: var(--black);
    font-weight: 600;
    margin: 0 0 16px;
  }


  .profile {
    position: relative;
    width: 100%;
    z-index: 3;

    .icon-arrow {
      position: absolute;
      right: -50px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--white);
      font-size: 28px;
      cursor: pointer;
      transition: all ease-in-out 0.3s;
    }
  }

  .profile-text {
    .pic {
      width: 45px;
      height: 45px;
      border-radius: 50px;
      overflow: hidden;
      flex-shrink: 0;
      position: relative;
      cursor: pointer;

      &:before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.2);
        opacity: 0;
        transition: 0.5s;
      }

      &:hover {
        &:before {
          opacity: 1;
        }

        .arrow-icon {
          opacity: 1;
          margin: 0;
        }
      }

      .arrow-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(50deg);
        margin: 30px 0px 0 -30px;
        transition: 0.3s;
        color: var(--white);
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
`;

export const StyledSenderSideBar = styled.div`
  width: 100%;
  /* max-width: 275px; */

  .names-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 5px 10px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 0;
    }
  }

  .name-holder {
    min-width: 48px;
    position: relative;
    text-align: center;
    cursor: pointer;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    text-transform: capitalize;
    color: #1c1c1c;
    border-radius: 50px;
    background: #fafafa;
    flex-shrink: 0;
    @media (min-width: 1450px) {
    font-size: 14px;
    line-height: 18px;
    }

    &.active {
      color: var(--white);
      background: var(--blue);
    }

    .message-counter {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -5px;
      right: -5px;
      width: 20px;
      height: 20px;
      font-size: 10px;
      line-height: 12px;
      color: var(--white);
      background: var(--blue);
      border: 1px solid var(--white);
      border-radius: 50%;
      text-align: center;
    }
  }

  ::-webkit-scrollbar {
    width: 3px;
  }
`;

export const StyledNameHolder = styled.div``;
